<template>
	<div class="notFound">
		<img src="~@/assets/image/404.png" />
		<el-button type="primary" @click="goBackHome" >返回首页</el-button>
	</div>
</template>

<script>
	export default {
		name: 'NotFound',
		methods: {
			goBackHome() {
				this.$router.push(this.staticPath)
			}
		}
	}
</script>

<style lang="less" scoped>
	.notFound {
		width: 100%;
		height: 100%;
		background: url('~@/assets/image/bg.png');
		background-size: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
</style>
